var React = require('react');

function WhitelistIconLog (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.7803 2.46967C12.0732 2.76256 12.0732 3.23744 11.7803 3.53033L5.25 10.0607L1.71967 6.53033C1.42678 6.23744 1.42678 5.76256 1.71967 5.46967C2.01256 5.17678 2.48744 5.17678 2.78033 5.46967L5.25 7.93934L10.7197 2.46967C11.0126 2.17678 11.4874 2.17678 11.7803 2.46967Z","fill":"#E8EFFF"})));
}

WhitelistIconLog.defaultProps = {"width":"13","height":"12","viewBox":"0 0 13 12","fill":"none"};

module.exports = WhitelistIconLog;

WhitelistIconLog.default = WhitelistIconLog;
